import withCTAProps from './withCTAProps';

export default withCTAProps;
